import React from "react";
import { Navigate } from "react-router-dom";
import ParentJobApplication from "./parent-job-application";
import CareerInterest from "../auth/sign-up/components/youth-sign-up/CareerInterest";
import PdfComponent from "../youth-job-application/pdfCompoent";
import ProofofAge from "../youth-job-application/proofofAge";
import ProofofResidence from "../youth-job-application/proofofResidence";
import ProofofSSN from "../youth-job-application/proofofSSN";
import ProofofWork from "../youth-job-application/proofofWork";
import TransportDetails from "../youth-job-application/transportDetails";
import ParentConsentFormAddPage from "../youth-job-application/parentConsentFormAdd";

export const ParentJobApplicationRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "parent/job-application",
      element: <ParentJobApplication />,
      children: [
        {
          path: "",
          element: <Navigate to="career-interest" />,
        },
        {
          path: "career-interest",
          element: <CareerInterest isReadOnly />,
        },
        {
          path: "application-resume",
          element: <PdfComponent isReadOnly />,
        },
        {
          path: "proof-of-age",
          element: <ProofofAge isReadOnly />,
        },
        {
          path: "proof-of-residency",
          element: <ProofofResidence isReadOnly />,
        },
        {
          path: "proof-of-ssn",
          element: <ProofofSSN isReadOnly />,
        },
        {
          path: "proof-of-work",
          element: <ProofofWork isReadOnly />,
        },
        {
          path: "transportation",
          element: <TransportDetails isReadOnly />,
        },
        {
          path: "parent-consent-form",
          element: (
            <ParentConsentFormAddPage
              isParent={false}
              isAdmin={false}
              isReadOnly
            />
          ),
        },
      ],
    },
  ],
};
